import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import ImageView from 'lib/images/image-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import IconUserFull from 'four-nets/icons/svg/icon_user-full.svg';
import IconMessageFull from 'four-nets/icons/svg/icon_message-full.svg';
import IconLikeFull from 'four-nets/icons/svg/icon_like-2.svg';

import VendorBadge from 'four-nets/ui-v2/badges/vendor-badge/vendor-badge';
import { LatestAlbumFragment } from 'four-nets/photoblog/latest-albums/latest-album/latest-album.graphql';
import { getFirstImage, getAlt } from 'four-nets/photoblog/latest-albums/latest-album/latest-album';

import likeStyles from './like-styles.scss';
import defaultStyles from './vendor-latest-album.scss';

interface Props extends LatestAlbumFragment {
    styles: typeof defaultStyles;
}

const VendorLatestAlbum: React.FC<Props> = props => {
    const { styles, slug, user, title, images, likesCount, commentCount } = props;

    const firstImage = getFirstImage(images);
    const firstImageAlt = getAlt(images);
    let username = '';
    if (user) {
        username = user.username;
    }

    return (
        <div className={styles.album}>
            <a href={`/catalog/vendor/${username}/blog-album/${slug}/`} className={styles.link}>
                <div className={styles.image}>
                    {firstImage ? (
                        <ImageView
                            aspectFill={true}
                            srcSet={firstImage.srcset || ''}
                            src={firstImage.src}
                            sizes={{ xs: '50vw', md: 300 }}
                            alt={firstImageAlt}
                            linkify={false}
                        />
                    ) : null}
                </div>
                <p className={styles.title}>{title}</p>
            </a>
            <div className={styles.stats}>
                <Link className={styles.link} to={`/catalog/vendor/${username}/`}>
                    <SVGIcon style={{ image: styles.icon }} src={IconUserFull} />
                    <span className={styles.stat}>{username}</span>
                    <VendorBadge style={{ badge: styles.vendorBadge }} />
                </Link>
                <div className={styles.divider} />
                <SVGIcon style={{ image: likeStyles.icon }} src={IconLikeFull} />
                <span className={styles.stat}>{likesCount}</span>
                <div className={styles.divider} />
                <SVGIcon style={{ image: styles.icon }} src={IconMessageFull} />
                <span className={styles.stat}>{commentCount}</span>
            </div>
        </div>
    );
};

export default Styled(defaultStyles)(VendorLatestAlbum);
